export { default } from "./useTheme.mjs";